/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, forwardRef, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbDate, NgbDateStruct, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerService } from 'src/app/shared/services/datepicker.service';

@Component({
  selector: 'datepicker',
  templateUrl: './datepicker.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => {
        return DatepickerComponent;
      }),
      multi: true,
    },
  ],
})
export class DatepickerComponent implements ControlValueAccessor {
  @ViewChild('t') tooltip: NgbTooltip;

  @Input() disabled = false;
  @Input() class: string;
  @Input() mask = 'M0/d0/0000';
  @Input() placeholder = 'mm/dd/yyyy';
  @Input() parseDateFormat = 'MM/dd/yyyy';
  @Input() hasTooltipValidation = false;
  @Input() addEndOfDayTime = false;
  @Input() maxDate: NgbDateStruct;
  @Input() minDate: NgbDateStruct;

  value: string;
  formatedValue?: string;
  calendarValue?: NgbDateStruct;

  isDateInvalid: boolean;
  validationMessage =
    "Entered date is invalid. Plese, follow next format: 'mm/dd/yyyy'";

  onChange: (value?: string) => void;
  onTouched: () => void;

  private readonly MASKED_DATE_VALUE_LENGTH: number = 10;

  constructor(private datepickerService: DatepickerService) {}

  //#region ControlValueAccessor

  writeValue(value: Date | string) {
    this.value = this.datepickerService.formatDate(value);
    this.onValueChanged();
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  //#endregion

  onValueChanged() {
    this.onChange(this.formatedValue);
  }

  onDateSelect(date: NgbDate): void {
    this.isDateInvalid = false;

    const dateTime = this.getUpdatetDateTime(date);

    if (dateTime) {
      this.value = this.datepickerService.formatDate(dateTime.toJSDate());
      this.formatedValue = this.datepickerService.toISOStringInUTC(dateTime);
    }

    this.onValueChanged();
  }

  onDateInputChange(str: string) {
    if (str.length === this.MASKED_DATE_VALUE_LENGTH) {
      this.calendarValue = this.datepickerService.toNgbDate(
        str,
        this.parseDateFormat,
      );

      const dateTime = this.getUpdatetDateTime(str);
      if (dateTime) {
        this.formatedValue = this.datepickerService.toISOStringInUTC(dateTime);
      }

      this.onValueChanged();
    } else if (str.length === 0) {
      this.formatedValue = '';
      this.onValueChanged();
    }
  }

  private getUpdatetDateTime(date: NgbDate | string) {
    let dateTime = this.datepickerService.toDateTime(
      date,
      this.parseDateFormat,
    );

    if (this.addEndOfDayTime) {
      dateTime = dateTime?.endOf('day');
    }

    return dateTime;
  }

  onBlur(event) {
    const valueLength = event.target.value.length;
    if (valueLength < this.MASKED_DATE_VALUE_LENGTH && valueLength > 0) {
      this.isDateInvalid = true;
      this.tooltip.open();
    } else {
      this.isDateInvalid = false;
      this.tooltip.close();
    }
  }
}
